/* eslint-disable import/prefer-default-export */
import { SUBMIT_FORM } from './constants';

export const submitForm = ({ form }) => ({ type: SUBMIT_FORM, form });


